import React from "react";
import { useState, useEffect, useMemo, forwardRef } from "react";
import { DataGrid, getGridDateOperators} from '@mui/x-data-grid';
import parse, { domToReact } from "html-react-parser";
import Box from '@mui/material/Box';
import "./styles/Mensajes.css";
import {  Link } from 'react-router-dom';
import { esES } from '@mui/x-data-grid/locales';
import {Dialog, AppBar, Toolbar, IconButton, Slide, TextField, DialogTitle, DialogContent, DialogActions, Button, Typography, Icon} from '@mui/material';
import { IoIosAttach } from "react-icons/io";
import { Chip } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import Swal from 'sweetalert2';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

let baseUrl;
if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
else baseUrl='https://app-formacion.vercel.app';

//Ordenación
//Ordenar Texto
const compararTexto = (v1, v2) => {
    const cad1 = v1.toString();
    const cad2 = v2.toString();
    return cad1 > cad2 ? 1 : cad1 < cad2 ? -1 : 0;
};

//Ordenar Fecha
const compararFecha = (v1, v2) => new Date(v1) - new Date(v2);

//Filtrado
//Filtrar Fecha
function ValorFechaIntroducido(props) {
    const { item, applyValue, focusElementRef } = props;

    // Estado para la fecha
    const [fecha, setFecha] = useState(
        item.value
          ? new Date(item.value).toISOString().split('T')[0]  // Convierte el Date a "YYYY-MM-DD"
          : ''
      );
      const dateRef = React.useRef(null);

    React.useImperativeHandle(focusElementRef, () => ({
        focus: () => {
            if (dateRef.current) {
                dateRef.current.focus();
            }
        },
    }));

    const handleFilterChange = (event) => {
        const newValue = event.target.value; // Viene en "YYYY-MM-DD"
        setFecha(newValue);
        if (newValue === '') {
          applyValue({ ...item, value: null });
        } else {
          const dateObj = new Date(newValue);
          if (!isNaN(dateObj)) {
            applyValue({ ...item, value: dateObj }); // Se envía el objeto Date
          } else {
            applyValue({ ...item, value: null });
          }
        }
    };
    
    return (
    <Box
        sx={{
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: 48,
            pl: '20px',
        }}
        >
        
        <TextField
            label="Fecha"
            type="date"
            value={fecha}
            onChange={handleFilterChange}
            inputRef={dateRef}
            InputLabelProps={{
                shrink: true,
            }}
        />
    </Box>
    );
}

//Grid
const MensajesGrid = ({ mensajes, onRowClick, tipo={tipo} }) => {
    const columns = useMemo(() => [
        {
            field: 'usuario',
            headerName: tipo === 'recibidos' ? 'Recibido de' : 'Enviado a',
            width: 400,
            sortable: true,
            filterable: true,
            renderCell: (params) => {
                if (tipo === 'recibidos') {
                // Si remitente es null o vacío
                const remitente = params.row.remitente;
                if (!remitente) {
                    return (
                        <div style={{ fontStyle: 'italic', color: '#888' }}>
                            Usuario eliminado
                        </div>
                    );
                }
                    return <span>{remitente}</span>;
                } 
                else {
                    const dest = params.row.destinatarios;
                    if (!dest || (Array.isArray(dest) && dest.length === 0)) {
                        return (
                        <div style={{ fontStyle: 'italic', color: '#888' }}>
                            Usuario eliminado
                        </div>
                        );
                    }
                    return (
                        <span>
                        {Array.isArray(dest) ? dest.join(', ') : dest}
                        </span>
                    );
                }
            },
            valueGetter: (value, row) => tipo === 'recibidos' ? (row.remitente || '')  : (Array.isArray(row.destinatarios) ? (row.destinatarios.join(', ')) : (row.destinatarios || '')),
            sortComparator: compararTexto,
        },
        {
            field: 'asunto',
            headerName: 'Asunto',
            width: 400,
            sortable: true,
            filterable: true,
            valueGetter: (value, row) => row.Asunto || '',
            sortComparator: compararTexto,
        },
        {
            field: 'fecha',
            headerName: 'Fecha',
            width: 350,
            sortable: true,
            firterable: true,
            valueGetter: (value, row) => new Date(row.Fecha),
            renderCell: (params) => {
                const rawFecha = params.row.Fecha;
                const fecha = new Date(rawFecha);
                if (isNaN(fecha)) return "Fecha inválida";
                return fecha.toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                }).replace(/\//g, "-");
            },
            sortComparator: compararFecha,
            filterOperators: getGridDateOperators()
                .filter((operator) => operator.value !== 'isAnyOf')
                .map((operator) => ({
                    ...operator,
                    InputComponent: operator.InputComponent
                        ? ValorFechaIntroducido
                        : undefined,
                })), 
        }
    ], [tipo]);

    return (
        <div className="gridContainer">
            <DataGrid 
                rows={mensajes}
                columns={columns.map(col => ({
                    ...col,
                    headerAlign: 'center', // Centra el encabezado de la columna
                    align: 'center', // Centra el contenido de la celda
                }))}
                pagesize={20}
                rowsPerPageOptions={[20]}
                disableSelectionOnClick
                onRowClick={(params) => onRowClick(params.row)}
                getRowId={(row) => row._id.toString()} 
                sx={{
                    borderColor: 'var(--text-principal)',
                    color: 'var(--text-principal)', 
                    fontSize: "14px",
                    '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#fff',
                        color: 'black',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        borderBottom: '0.25px solid var(--text-principal)'
                    },
                    "& .MuiTablePagination-displayedRows": {
                        color: "#fff", 
                    },
                    "& .MuiDataGrid-footerContainer": {
                        color: 'var(--text-principal)', 
                        fontWeight: "bold",
                    },
                    '& .MuiSvgIcon-root': {
                        color: 'black', // Cambia el color de los íconos en general (como la flecha de ordenación y los tres puntos)
                    },
                    '& .MuiDataGrid-sortIcon': {
                        color: 'black', // Cambia el color de la flecha de ordenación
                    },
                    '& .MuiDataGrid-menuIconButton svg': {
                        color: 'black', // Cambia el color del ícono del menú de la columna (los tres puntos)
                    },
                    // 'Filas por página:' texto
                    "& .MuiTablePagination-selectLabel": {
                        color: 'var(--text-principal)',
                    },
                
                    // Selector desplegable (100)
                    "& .MuiInputBase-root": {
                        color: "var(--text-principal)",
                    },
                
                    // Opciones del selector al abrirse
                    "& .MuiMenuItem-root": {
                        color: "black", // texto de los items cuando se despliega el select
                    },
                
                    // '1–7 de 7'
                    "& .MuiTablePagination-displayedRows": {
                        color: "var(--text-principal)",
                    },
                
                    // Flechas de navegación
                    "& .MuiSvgIcon-root": {
                        color: "var(--text-principal)",
                    },
                    // Bordes de las filas
                    '& .MuiDataGrid-row': {
                        borderBottom: '0.25px solid var(--text-principal)', 
                    },
                    // Borde del selector
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#fff",
                    },
                
                    // Icono del desplegable
                    "& .MuiSelect-icon": {
                        color: "var(--text-principal)",
                    },
                    // Icono menú cabecera
                    "& .MuiDataGrid-columnHeaderMenuIcon": {
                        color: "black",
                    },
                }}
                localeText={{
                    ...esES.components.MuiDataGrid.defaultProps.localeText,
                    rowsPerPage: "Filas por página:",
                }}
                
            />
        </div>
    );
}

//Dialogos
//Ver detalles 
function DetalleMensajeDialog({ abierto, onClose, mensaje, onShowDetail }){
    
  if (!mensaje) return null;

  // Parseamos el HTML y sustituimos el <button data-msgid="..."> por nuestro componente
  const contenidoReact = parse(mensaje.Contenido || "", {
    replace: (node) => {
      if (
        node.type === "tag" &&
        node.name === "button" &&
        node.attribs?.["data-msgid"]
      ) {
        const msgId = node.attribs["data-msgid"];
        return (
          <Button
            size="small"
            sx={{ 
                ml: -0.7, mb: 0.7, textTransform: 'none',  fontSize: 'inherit', fontFamily: 'inherit',fontWeight: 'inherit'
            }}
            onClick={() => {
              onClose();
              onShowDetail(msgId);
            }}
          >
            {domToReact(node.children)}
          </Button>
        );
      }
    },
  });

    const remitenteEliminado = !mensaje.remitente;
    
    return (
        <Dialog open={abierto} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Detalles del mensaje</DialogTitle>
            <DialogContent dividers sx={{ 
                fontFamily: 'inherit', 
                fontSize: 'inherit', 
                fontWeight: 'inherit', 
                color: 'inherit', 
                textTransform: 'none',
            }}>
                <Typography><strong>De: </strong> 
                    {remitenteEliminado ? ( 
                        <span style={{ fontStyle: "italic", color: "#888" }}>
                            Usuario eliminado
                        </span>
                    ) : ( mensaje.remitente )}
                </Typography>
                <Typography><strong>Para: </strong> {Array.isArray(mensaje.destinatarios) ? mensaje.destinatarios.join(', ') : mensaje.destinatarios}</Typography>
                <Typography><strong>Asunto: </strong> {mensaje.Asunto}</Typography>
                
                {/*<Typography sx={{mt: 2}}>{mensaje.Contenido}</Typography>*/}
                <Box sx={{ mt: 2 }}>
                    {contenidoReact}
                </Box>

                {mensaje.ArchivoAdjunto && (
                    <Button
                        sx={{
                            textTransform: 'none',
                            fontSize: 'inherit',
                            fontFamily: 'inherit',
                            fontWeight: 'inherit',
                            p: 0, 
                            minWidth: 0, 
                        }}
                        component="a"
                        href={`${baseUrl}/api/mensajes/${mensaje._id}/archivo`}
                        download
                    >
                        Descargar archivo adjunto
                    </Button>
                )}
            </DialogContent>
            <DialogActions>
                <Button sx={{textTransform: 'none'}} onClick={onClose}>Cerrar</Button>
                {!remitenteEliminado && mensaje.remitente !== 'Sistema' && (
                    <Button sx={{textTransform: 'none'}} onClick={() => onClose({ reply: true })}>Responder</Button>
                )}
            </DialogActions>
        </Dialog>
    );
}

//Redactar / Respuesta
function ComponerMensajeDialog({ abierto, onClose, inicial, onShowDetail }){
    //Usuario logueado
    const [usuario] = useState(() => {
        const usuarioAlmacenado = localStorage.getItem("userLogueado");
        return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    });
    
    /*const [formulario, setFormulario] = useState({
        Destinatarios: inicial?.Destinatario || '',
        Asunto: inicial?.Asunto || '',
        Contenido: inicial?.Contenido || '',
        Archivo: null,
    });*/

    const [formulario, setFormulario] = useState({
        Destinatarios: "",
        Asunto: "",
        Contenido: "",
        Archivo: null,
    });


    useEffect(() => {
        if(abierto){
            //Reiniciar campos del formulario:
            setFormulario({
                Destinatarios: "",
                Asunto: "",
                Contenido: "",
                Archivo: null,
            });
            
            if(inicial?.respuestaA){
                const destinatario = inicial.remitente;
                const nuevoAsunto = `Re: ${inicial.Asunto}`;
                
                setFormulario(f => ({
                    ...f,
                    Destinatarios: destinatario,
                    Asunto: nuevoAsunto,
                }));   
            }
            else if(inicial.Destinatarios !== "" && inicial.Asunto === ""){
                setFormulario(f => ({
                    ...f,
                    Destinatarios: inicial.Destinatarios,
                })); 
            }
            else if(inicial.Destinatarios != "" && inicial.Asunto !== ""){
                setFormulario(f => ({
                    ...f,
                    Destinatarios: inicial.Destinatarios,
                    Asunto: inicial.Asunto
                })); 
            }
            else{
                setFormulario(f => ({
                    Destinatarios: "",
                    Asunto: "",
                    Contenido: "",
                    Archivo: null,
                }));   
            }
        }
    }, [abierto, inicial]);

    const handleChange = (field) => (e) => {
        setFormulario((f) => ({ ...f, [field]: e.target.value }));
    };

    const handleFile = (e) => {
        const fichero = e.target.files[0];
        setFormulario((f) => ({ ...f, Archivo: fichero || null }));
    };

    const removeFile = () => {
        setFormulario((f) => ({ ...f, Archivo: null }));
    };


    const handleSubmit = async () => {
        //Validaciones: 
        const { Destinatarios, Asunto, Contenido } = formulario;

        // Validaciones básicas
        if (!Destinatarios.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Destinatario requerido',
                text: 'Debe indicar al menos un destinatario.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        if (!Asunto.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Asunto requerido',
                text: 'Debe escribir un asunto.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        if (!Contenido.trim()) {
           Swal.fire({
                icon: 'warning',
                title: 'Contenido requerido',
                text: 'Debe escribir un contenido.',
                confirmButtonText: 'Aceptar'
            });
            return;
        }

        // Traducir usuario a Id
        const usuariosDestinatarios = formulario.Destinatarios.split(',').map(u => u.trim());
        const idPromises = usuariosDestinatarios.map(async u => {
            const resp = await fetch(`${baseUrl}/api/users/search/${u}`);
            if (!resp.ok) throw new Error(`Usuario no encontrado: ${u}`);
            const us = await resp.json();
            return us._id;
        });

        let destIds;
        try {
            destIds = await Promise.all(idPromises);
        } catch (err) {
            return Swal.fire({
                icon: 'error',
                title: 'Error',
                text: err.message || 'Ha ocurrido un error inesperado.',
                confirmButtonText: 'Aceptar'
            });
        }

         // Montar el contenido final: inyectar la línea bloqueada al principio
        let cuerpo = formulario.Contenido;
        if (esRespuesta) {
            // crear el enlace que abre el detalle
            const enlace = `<button data-msgid="${inicial.respuestaA}">
                            Mensaje como respuesta a ${inicial.Asunto}
                            </button>\n\n`;

            cuerpo = enlace + cuerpo;

        }

        //Enviar datos
        const datos = new FormData();

        datos.append('Remitente', usuario._id);
        datos.append('Destinatarios', JSON.stringify(destIds));
        datos.append('Asunto', formulario.Asunto);
        datos.append('Contenido', cuerpo);
        if (inicial?.respuestaA) datos.append('respuestaA', inicial.respuestaA);
        if (formulario.Archivo) datos.append('Archivo', formulario.Archivo);
        await fetch(`${baseUrl}/api/mensajes`, { method: 'POST', body: datos });
        onClose();
    };

    // detectamos si estamos en modo respuesta
    const esRespuesta = Boolean(inicial?.respuestaA);

    return (
        <Dialog fullScreen open={abierto} onClose={() => onClose()} TransitionComponent={Transition}>
          <AppBar sx={{ position: 'relative'}}>
            <Toolbar sx={{zIndex: 30000}}>
              <IconButton edge="start" color="inherit" onClick={() => onClose()} aria-label="close">
                <Icon>X</Icon>
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
                {inicial.respuestaA ? 'Responder mensaje' : 'Nuevo mensaje'}
              </Typography>
            </Toolbar>
          </AppBar>
          <DialogContent>
            <Box sx={{ mt: 2 }}>
                <TextField
                    fullWidth
                    label="Destinatarios"
                    value={formulario.Destinatarios}
                    onChange={handleChange('Destinatarios')}
                    margin="normal"
                    disabled={esRespuesta || Boolean(inicial?.leerSoloDestinatarios)}
                />
                <TextField
                    fullWidth
                    label="Asunto"
                    value={formulario.Asunto}
                    onChange={handleChange('Asunto')}
                    margin="normal"
                    disabled={esRespuesta || Boolean(inicial?.leerSoloAsunto)}
                />

                {/* Línea fija de respuesta como botón */}
                {esRespuesta && (
                    <Box sx={{ my: 1, font: 'inherit' }}>
                        <Button
                            sx={{textTransform: 'none', font: 'inherit'}}
                            size="small"
                            onClick={() => onShowDetail(inicial)}
                        >
                        <Typography sx={{ font: 'inherit' }} component="span">
                            Mensaje como respuesta a
                        </Typography>
                        <Typography component="span" sx={{ ml: 0.5, fontWeight: 'bold', font: 'inherit' }}>
                            {inicial.Asunto}
                        </Typography>
                        </Button>
                    </Box>
                )}
                <TextField
                    fullWidth
                    label="Contenido"
                    multiline
                    rows={6}
                    value={formulario.Contenido}
                    onChange={handleChange('Contenido')}
                    margin="normal"
                />
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Button variant="outlined" component="label" startIcon={<IoIosAttach />} sx={{ mt:2, mr:2, textTransform: 'none' }}>
                        {formulario.Archivo ? "Cambiar archivo" : "Adjuntar archivo"}
                        <input type="file" hidden onChange={handleFile} />
                    </Button>

                    {formulario.Archivo && (
                        <Box sx={{ mt: 2.5 }}>
                            <Chip
                                label={formulario.Archivo.name}
                                onDelete={removeFile}
                                deleteIcon={<IoMdClose />}
                                variant="outlined"
                            />
                        </Box>
                    )}
                </Box>
                <Button variant="contained" sx={{ mt: 2, textTransform: 'none' }} onClick={handleSubmit} disabled={!(formulario.Destinatarios || '').trim() || !(formulario.Asunto || '').trim() || !(formulario.Contenido || '').trim()}>
                    Enviar
                </Button>
            </Box>
          </DialogContent>
        </Dialog>
      );
}

//Pagina principal
const Mensajes = () => {
    //Usuario logueado
    const [usuario] = useState(() => {
        const usuarioAlmacenado = localStorage.getItem("userLogueado");
        return usuarioAlmacenado ? JSON.parse(usuarioAlmacenado) : null;
    });

    const [mensajes, setMensajes] = useState([]);

    //Mensajes enviados o mensajes recibidos
    const [tipo, setTipo] = useState('recibidos');

    //Cargar página
    const [loading, setLoading] = useState(true);

    //Modal para ver el correo completo
    const [detalle, setDetalle] = useState({ abierto: false, datos: null });

    //Mostrar mensajes anteriores si el actual es una respuesta
    const [compose, setCompose] = useState({ abierto: false, inicial: {} });

    // Traer mensajes
    const fetchRecibidos = () =>
        fetch(`${baseUrl}/api/mensajes/search/recibidos/${usuario._id}`)
          .then(r => { 
            if (!r.ok) throw new Error('Error fetch recibidos'); 
            return r.json(); 
        });

    const fetchEnviados = () =>
        fetch(`${baseUrl}/api/mensajes/search/enviados/${usuario._id}`)
          .then(r => { if (!r.ok) throw new Error('Error fetch enviados'); 
            return r.json(); 
        });

    const cargar = async (tipo) => {
        setLoading(true);
        try {
            const datos = tipo === 'enviados' ? await fetchEnviados() : await fetchRecibidos();
            setMensajes(datos);
            setTipo(tipo);
        } catch (err) {
            console.error('Error cargando mensajes:', err);
            setMensajes([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(()=>{ cargar('recibidos') }, []);

    //Al pulsar una fila del grid se abre los detalles del mensaje
    const handleRowClick = (msg) => {
        setDetalle({ abierto: true, datos: msg });
    };

    //Manejar cierre
    const handleDetalleClose = (action) => {
        if (action?.reply) {
            setCompose({ 
                abierto: true, 
                inicial: {
                    ...detalle.datos, respuestaA:detalle.datos._id
                } 
            });
        }
        setDetalle({ abierto: false, data: null });
    };
    
    return(
        <div className="principal">
            <h1>Mensajes</h1> 
            <div className="containerMensajes">
                <div className="botonesMensajes">
                    <Button sx={{textTransform: 'none'}} variant={tipo === 'recibidos' ? 'contained' : 'text'} onClick={() => cargar('recibidos')}>Recibidos</Button>
                    <Button sx={{textTransform: 'none'}} variant={tipo === 'enviados' ? 'contained' : 'text'} onClick={()=>cargar('enviados')}>Enviados</Button>
                    <Button sx={{textTransform: 'none'}} onClick={() => setCompose({ abierto:true, inicial:{} })}>Redactar</Button>
                </div>

                {loading ? (
                    <div className="noMensajes">
                        <p>Cargando mensajes...</p>
                    </div>
                    ) : mensajes.length === 0 ? (
                        <div className="noMensajes">
                            <p>Aún no hay mensajes</p>
                        </div> 
                    ) : ( 
                        <MensajesGrid mensajes={mensajes} onRowClick={handleRowClick} tipo={tipo}/> 
                    )
                }
            </div>

            {/*Modal para ver mensaje completo*/}
            <DetalleMensajeDialog
                abierto={detalle.abierto}
                mensaje={detalle.datos}
                onClose={handleDetalleClose}
                BackdropProps={{
                    onMouseDown: e => e.stopPropagation(),
                }}
                PaperProps={{
                    onMouseDown: e => e.stopPropagation(),
                }}
                onShowDetail={async (msgId) => {
                    try {
                        const res = await fetch(`${baseUrl}/api/mensajes/${msgId}`);
                        if (!res.ok) throw new Error('No encontrado');
                        const fullMsg = await res.json();
                        setDetalle({ abierto: true, datos: fullMsg });
                    } catch (err) {
                        console.error(err);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al cargar el mensaje',
                            confirmButtonText: 'Aceptar'
                        });                   
                    }
                }}
            />

            {/*Modal para redactar */}
            <ComponerMensajeDialog
                abierto={compose.abierto}
                inicial={compose.inicial}
                onClose={() => setCompose({ abierto: false, inicial: {} })}
                onShowDetail={(msg) => setDetalle({ abierto: true, datos: msg })}
            />

        </div>
    );
};

export default Mensajes;

export { ComponerMensajeDialog };
export { DetalleMensajeDialog };